export enum WorkingSlotStatusType {
  Attendance = "Attendance",
  OutOfOffice = "OutOfOffice"
}
